import React from 'react';
import {Table, Loader} from 'semantic-ui-react';
import SummaryByTransferModal from './summaryByTransferModal';
import SummaryByRequestModal from './summaryByRequestModal';

export const AccessoriesSummaryTable = ({loading, accessoriesSummaryList}) => {
  /* const totalRequestedPending = (accesoryDetail) => {
    const requestedValue = accesoryDetail.requests.map((x) => {
      if (x.request && x.delivered === 0) {
        return x.requested;
      }
      return 0;
    }).reduce((acc, val) => {
      return acc + val;
    });
    return requestedValue;
  }; */

  return (
    loading ?
      <Table>
        <Table.Body>
          <Table.Row className='loader'>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table> :
      <Table striped className='dashboard-table'>
        <Table.Header className='orders-table-header'>
          <Table.Row>
            <Table.HeaderCell>Accesorios</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Transferidos</Table.HeaderCell>
            {/* <Table.HeaderCell>Solicitados</Table.HeaderCell> */}
            <Table.HeaderCell>Entregados</Table.HeaderCell>
            <Table.HeaderCell>Disponibles</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            accessoriesSummaryList.map((detail, index) => {
              return <Table.Row key={index}>
                <Table.Cell>{detail.accessory}</Table.Cell>
                <Table.Cell>{detail.accessoryName}</Table.Cell>
                <Table.Cell>
                  <SummaryByTransferModal accessoryTransferredTotal={detail.transferred}
                    accessoryTransfersList={detail.transfers} />
                </Table.Cell>
                {/* <Table.Cell>
                  <SummaryByRequestModal accessoryRequestedTotal={totalRequestedPending(detail)}
                    accessoryRequestsList={detail.requests.filter((x) => x.request && x.delivered === 0)} />
                </Table.Cell> */}
                <Table.Cell>
                  <SummaryByRequestModal accessoryRequestedTotal={detail.delivered}
                    accessoryRequestsList={detail.requests.filter((x) => x.request && x.delivered > 0)} />
                </Table.Cell>
                <Table.Cell><strong>{detail.available}</strong></Table.Cell>
              </Table.Row>;
            })
          }
        </Table.Body>
      </Table>
  );
};
